/*
* Edit Association view for authenticated users
*/

import { compose } from 'redux';
import { connect } from 'react-redux';
import { connectRequest } from 'redux-query';
import { push } from 'react-router-redux';
import { Row, Well, Button, ButtonToolbar, ButtonGroup } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import * as _ from 'lodash';
import * as React from 'react';

import * as AppComp from '../common/app-component-base';
import * as KendoWrappers from '../common/kendoforms/componentwrappers';
import * as LK from '../config/apilookupkeys';
import * as MutateActions from '../actions/mutate';
import * as ReduxQueries from '../queries';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../common/formatters';
import { NavigationLinks } from '../common/navigation';
import { statesList, countriesList } from '../config/geolocations';
import { WhiteBoxPageSection } from '../common/whiteboxpagesection';
import ApiEndpoints from '../config/apiendpoints';

import { AssociationDetailsLocation } from './detail-form/association-details-location';
import { AssociationDetailsConstructionInformation } from './detail-form/association-details-construction-information';
import { AssociationDetailsCommonAreaAmenities } from './detail-form/association-details-common-area-amenities';
import { AssociationDetailsAmenityResponsibilitiesExteriorCheckboxes } from './detail-form/association-details-amenity-responsibilities-exterior-checkboxes';
import { AssociationDetailsAmenityResponsibilitiesExteriorNumeric } from './detail-form/association-details-amenity-responsibilities-exterior-numeric';
import { AssociationDetailsAmenityResponsibilitiesInterior } from './detail-form/association-details-amenity-responsibilities-interior';
import { AssociationDetails } from './detail-form/association-details';

import 'react-dropdown/style.css';
import '../inventory/detail-form/detail-form.css';
import { GeneralNotes } from './detail-form/common';
import { AssociationDetailsNotes } from './detail-form/association-details-notes';

export interface IEditAssociationProps extends AppComp.IAppComponentProps {
    associationId?: any;
    association?: any;
    clients?: any;
    updateAssociation?: any;
    navigateTo?: any;
    lookups?: any;
}

export interface IEditAssociationState extends AppComp.IAppComponentState {
    // client: any;
    // clientContacts: any;
    formChanges?: any;
}

class EditAssociation extends AppComp.AppComponent<IEditAssociationProps, IEditAssociationState> {
    public originalFormDataCache = {};

    public constructor(props: IEditAssociationProps) {
        super(props, 'app.association-edit.');

        this.state = {
            formChanges: {},
        };
    }

    public componentDidUpdate() {
        let resetFormData = this.getFormChangesResetRequired();
        if (resetFormData && _.size(this.state.formChanges)) {
            this.setState({ formChanges: {} });
        }
    }

    // Data transforms
    public extendAssociationData(record: any) {
        if (!record) { return; }

        let result = _.cloneDeep(record);

        return result;
    }

    // Handlers
    public handleSaveButton(e: any) {
        const token = _.get(this.props, 'authsession.access_token', '');

        const changeData = _.merge(
            {},
            { association: _.pick(this.props.association, ['associationId', '_id']) },
            { client: _.pick(this.props.association.client, ['clientId']) },
            this.state.formChanges
        );

        // console.log('handleSaveButton changeData', changeData);

        this.props.updateAssociation(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                this.originalFormDataCache = {};
                this.setState({ formChanges: {} });

                // Navigate to association detail view after saving changes
                this.props.navigateTo(NavigationLinks.associationDetail(this.props.associationId));
            } else {
                // Error during creation...
            }
        });
    }

    public handleFormInputChange(e: any, x: any) {
        // console.log('handleForminputchange', {e: e, x: x });

        const getChangesResult = this.getFormChanges(e, x);
        // console.log('handleForminputchange getChangesResult', {getChangesResult: getChangesResult, e: e, x: x });
        if (getChangesResult.applyChanges) {
            this.setState({
                formChanges: getChangesResult.formChanges
            });
        }
    }

    public handleFormSubmit(e: any) {
        // console.log('handleFormSubmit', e);
    }

    // Helpers
    public getFormChanges(e: any, x: any) {
        let result = {
            applyChanges: false,
            formChanges: {},
            formChangesResult: {},
        };

        let fieldName = '';
        let newValue;

        let formChangesCopy = _.cloneDeep(this.state.formChanges);

        if (_.get(e, 'target.props.name')) {
            // Kendo form element
            if (_.has(e, 'target.combobox')) {
                // combobox
                fieldName = _.get(e, 'target.props.name', '');
                newValue = _.get(e, 'target.value');
            } else {
                // assume textbox
                fieldName = _.get(e, 'target.props.name', '');
                newValue = _.get(e, 'value');
            }
        } else {
            const eventTargetType = _.get(e, 'target.type', '');

            switch (eventTargetType) {
                case 'textarea':
                case 'text':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(e, 'target.value');
                    break;

                case 'kendo-dropdownlist':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(e, 'target.value', '');
                    break;

                case 'virtualized-select':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(x, 'value');
                    break;

                case 'delete-button':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(e, 'target.value');
                    break;

                default:
                    // console.log(`*** handleFormInputChange switch hit default for eventTargetType ${eventTargetType}`);
                    break;
            }
        }

        // console.log(`handleFormInputChange continuing 1 fieldName ${fieldName} newValue ${newValue}`, { e: e, x: x });

        if (!fieldName) { return result; }

        let applyChange = false;
        let origVal = _.get(this.originalFormDataCache, fieldName);
        let formChangesResult = {};
        if (_.isArray(origVal)) {
            if (_.isArray(newValue)) {
                if (!_.isEqual(origVal, newValue)) {
                    _.set(formChangesCopy, fieldName, _.cloneDeep(newValue));
                    _.set(formChangesResult, fieldName, _.cloneDeep(newValue));
                    applyChange = true;
                } else {
                    applyChange = false;
                }
            } else {
                if (_.includes(origVal, newValue)) {
                    // console.log(`original array already contained val ${newValue} origVal`, origVal);
                    applyChange = false;
                } else {
                    const formChangesArr = _.get(formChangesCopy, fieldName, []);
                    // console.log(`${fieldName} formChangesArr`, formChangesArr);
                    if (_.includes(formChangesArr, newValue)) {
                        // console.log(`formChangesArr field ${fieldName} array already contains val ${newValue} formChangesArr`, formChangesArr);
                        applyChange = false;
                    } else {
                        formChangesArr.push(newValue);
                        _.set(formChangesCopy, fieldName, _.cloneDeep(formChangesArr));
                        _.set(formChangesResult, fieldName, _.cloneDeep(formChangesArr));
                        applyChange = true;
                        // console.log(`formChangesArr field ${fieldName} array DID NOT have val ${newValue}, applying change`, formChangesArr);
                    }
                }
            }
        } else {
            if (String(newValue) !== String(origVal)) {
                // New value
                _.set(formChangesCopy, fieldName, newValue);
                _.set(formChangesResult, fieldName, newValue);
                applyChange = true;
            } else {
                // Same as orig val
                if (_.has(formChangesCopy, fieldName)) {
                    _.unset(formChangesCopy, fieldName);
                    _.set(formChangesResult, fieldName, newValue);
                    applyChange = true;
                }
            }
        }

        if (applyChange) {
            result.applyChanges = true;
            result.formChanges = _.cloneDeep(formChangesCopy);
            result.formChangesResult = _.cloneDeep(formChangesResult);
        }

        // console.log(`getFormChanges returns result`, result);

        return result;
    }

    public buildOptions(lookups: any, key: any, srcValueField: any = 'name', srcTextField: any = 'name') {
        const l = _.get(lookups, key, []);

        if (_.size(l) <= 0) { return []; }

        return _.orderBy(l.map((c) => _.merge({}, { value: Formatters.getStr(c, srcValueField), text: Formatters.getStr(c, srcTextField) })), 'value');
    }

    public buildOptionsIntValue(lookups: any, key: any, srcValueField: any = 'name', srcTextField: any = 'name') {
        const l = _.get(lookups, key, []);

        if (_.size(l) <= 0) { return []; }

        return _.orderBy(l.map((c) => _.merge({}, { value: Formatters.getInt(c, srcValueField), text: Formatters.getStr(c, srcTextField) })), 'value');
    }

    public buildOptionsGeolocations(l: Array<any> = [], srcValueField: any = 'name', srcTextField: any = 'name') {
        if (_.size(l) <= 0) { return []; }

        return _.orderBy(l.map((c) => _.merge({}, { value: Formatters.getStr(c, srcValueField), text: Formatters.getStr(c, srcTextField) })), 'value');
    }

    public buildOptionsClientContacts(l: Array<any> = [], srcValueField: any = 'contactId') {
        if (_.size(l) <= 0) { return []; }

        const mapped = l.map((c) => {
            const contactName = Formatters.composeClientContactFormal(c);
            return _.merge({}, { value: Formatters.getInt(c, srcValueField), text: contactName });
        });

        return _.orderBy(mapped, 'text');
    }

    public getFormData(assocIn: any, lookups: any) {
        const assocMerged = _.merge(assocIn, this.state.formChanges);

        const clientId = Formatters.getInt(assocMerged, 'client.clientId');

        const clients = _.get(lookups, LK.LookupKeys.Clients);
        const assocClient = _.find(clients, { 'clientId': clientId });
        const assocClientContacts = _.get(assocClient, 'contacts', []);

        let result = {
            associationId: Formatters.getInt(assocMerged, 'associationId'),

            associationType: {
                associationTypeId: Formatters.getInt(assocMerged, 'associationType.associationTypeId'),
            },

            client: {
                clientId: clientId,
            },

            company: {
                companyId: Formatters.getInt(assocMerged, 'company.companyId'),
            },

            contact: {
                contactId: Formatters.getInt(assocMerged, 'contact.contactId'),
                email: Formatters.getStr(assocMerged, 'contact.email'),
                firstName: Formatters.getStr(assocMerged, 'contact.firstName'),
                lastName: Formatters.getStr(assocMerged, 'contact.lastName'),
                phone: Formatters.getStr(assocMerged, 'contact.phone'),
                title: Formatters.getStr(assocMerged, 'contact.title'),
                // salutation
                // notes
                // company
            },

            details: {
                constructDate: Formatters.getStr(assocMerged, 'details.constructDate'),
                converDate: Formatters.getStr(assocMerged, 'details.converDate'),
                elevators: Formatters.getStr(assocMerged, 'details.elevators'),
                executiveSummaryDetails: Formatters.getStr(assocMerged, 'details.executiveSummaryDetails'),
                fencing: Formatters.getStr(assocMerged, 'details.fencing'),
                fiscalYearEnd: Formatters.getStr(assocMerged, 'details.fiscalYearEnd'),
                inactive: _.get(assocMerged, 'details.inactive'),
                interiorHalls: Formatters.getStr(assocMerged, 'details.interiorHalls'),
                irrigation: Formatters.getStr(assocMerged, 'details.irrigation'),
                mechanical: Formatters.getStr(assocMerged, 'details.mechanical'),
                numberBuildings: Formatters.getInt(assocMerged, 'details.numberBuildings'),
                numberStories: Formatters.getInt(assocMerged, 'details.numberStories'),
                numberUnits: Formatters.getInt(assocMerged, 'details.numberUnits'),
                phases: Formatters.getStr(assocMerged, 'details.phases'),
                pools: Formatters.getInt(assocMerged, 'details.pools'),
                recRooms: Formatters.getStr(assocMerged, 'details.recRooms'),
                roofs: Formatters.getStr(assocMerged, 'details.roofs'),
                secured: Formatters.getStr(assocMerged, 'details.secured'),
                siding: Formatters.getStr(assocMerged, 'details.siding'),
                spas: Formatters.getInt(assocMerged, 'details.spas'),
                streets: Formatters.getStr(assocMerged, 'details.streets'),
                tennis: Formatters.getInt(assocMerged, 'details.tennis'),

                // new hoa amenities building exteriors and grounds boolean fields per rf22
                trashEnclosures: Formatters.getBool(assocMerged, 'details.trashEnclosures'),
                monumentSigns: Formatters.getBool(assocMerged, 'details.monumentSigns'),
                bikeWalkingPaths: Formatters.getBool(assocMerged, 'details.bikeWalkingPaths'),
                streetLighting: Formatters.getBool(assocMerged, 'details.streetLighting'),
                streetSigns: Formatters.getBool(assocMerged, 'details.streetSigns'),
                outdoorFurniture: Formatters.getBool(assocMerged, 'details.outdoorFurniture'),
                awnings: Formatters.getBool(assocMerged, 'details.awnings'),
                mailboxes: Formatters.getBool(assocMerged, 'details.mailboxes'),
                walkways: Formatters.getBool(assocMerged, 'details.walkways'),
                fireEscapes: Formatters.getBool(assocMerged, 'details.fireEscapes'),
                buildingLighting: Formatters.getBool(assocMerged, 'details.buildingLighting'),
                decksBalconies: Formatters.getBool(assocMerged, 'details.decksBalconies'),
                carports: Formatters.getBool(assocMerged, 'details.carports'),
                garages: Formatters.getBool(assocMerged, 'details.garages'),
                exteriorStairways: Formatters.getBool(assocMerged, 'details.exteriorStairways'),
                waterscapesFountains: Formatters.getBool(assocMerged, 'details.waterscapesFountains'),
                gazebos: Formatters.getBool(assocMerged, 'details.gazebos'),

                // new hoa amenities building exteriors and grounds number fields per rf22
                wadingPools: Formatters.getInt(assocMerged, 'details.wadingPools'),
                saunas: Formatters.getInt(assocMerged, 'details.saunas'),
                marinasDocks: Formatters.getInt(assocMerged, 'details.marinasDocks'),
                generators: Formatters.getInt(assocMerged, 'details.generators'),
                waterHeaters: Formatters.getInt(assocMerged, 'details.waterHeaters'),
                boilers: Formatters.getInt(assocMerged, 'details.boilers'),
                hvacUnits: Formatters.getInt(assocMerged, 'details.hvacUnits'),
                chillers: Formatters.getInt(assocMerged, 'details.chillers'),
                maintenanceBuildings: Formatters.getInt(assocMerged, 'details.maintenanceBuildings'),
                volleyballCourts: Formatters.getInt(assocMerged, 'details.volleyballCourts'),
                basketballCourts: Formatters.getInt(assocMerged, 'details.basketballCourts'),

                // new hoa amenities building interiors boolean fields per rf22v
                interiorLighting: Formatters.getBool(assocMerged, 'details.interiorLighting'),
                interiorPainting: Formatters.getBool(assocMerged, 'details.interiorPainting'),
                interiorFloors: Formatters.getBool(assocMerged, 'details.interiorFloors'),
                office: Formatters.getBool(assocMerged, 'details.office'),
                laundryEquipment: Formatters.getBool(assocMerged, 'details.laundryEquipment'),
                playgroundEquipment: Formatters.getBool(assocMerged, 'details.playgroundEquipment'),
                interiorElevators: Formatters.getBool(assocMerged, 'details.interiorElevators'),
                kitchen: Formatters.getBool(assocMerged, 'details.kitchen'),
                gym: Formatters.getBool(assocMerged, 'details.gym'),
                restrooms: Formatters.getBool(assocMerged, 'details.restrooms'),
            },

            // inventorySubgroups

            location: {
                address1: Formatters.getStr(assocMerged, 'location.address1'),
                address2: Formatters.getStr(assocMerged, 'location.address2'),
                city: Formatters.getStr(assocMerged, 'location.city'),
                country: Formatters.getStr(assocMerged, 'location.country'),
                countryCode: Formatters.getStr(assocMerged, 'location.countryCode'),
                name: Formatters.getStr(assocMerged, 'location.name'),
                postalCode: Formatters.getStr(assocMerged, 'location.postalCode'),
                state: Formatters.getStr(assocMerged, 'location.state'),
                stateCode: Formatters.getStr(assocMerged, 'location.stateCode'),
            },

            name: Formatters.getStr(assocMerged, 'name'),
            assocNotes: _.get(assocMerged, 'assocNotes'),
            assocNotesDelete: _.get(assocMerged, 'assocNotesDelete'),

            options: {
                associationTypes: this.buildOptionsIntValue(lookups, LK.LookupKeys.AssociationTypes, 'associationTypeId', 'name'),
                companyTypes: this.buildOptionsIntValue(lookups, LK.LookupKeys.Companies, 'companyId', 'name'),
                clientContacts: this.buildOptionsClientContacts(assocClientContacts, 'contactId'),
                clients: this.buildOptionsIntValue(lookups, LK.LookupKeys.Clients, 'clientId', 'name'),
                states: this.buildOptionsGeolocations(statesList, 'stateCode', 'name'),
                countries: this.buildOptionsGeolocations(countriesList, 'countryCode', 'name'),

                elevatorTypes: this.buildOptions(lookups, LK.LookupKeys.ElevatorTypes),
                fencingTypes: this.buildOptions(lookups, LK.LookupKeys.FencingTypes),
                interiorHallTypes: this.buildOptions(lookups, LK.LookupKeys.InteriorHallTypes),
                irrigationTypes: this.buildOptions(lookups, LK.LookupKeys.IrrigationTypes),
                mechanicalTypes: this.buildOptions(lookups, LK.LookupKeys.MechanicalTypes),
                recRoomTypes: this.buildOptions(lookups, LK.LookupKeys.RecRoomTypes),
                roofTypes: this.buildOptions(lookups, LK.LookupKeys.RoofTypes),
                securedTypes: this.buildOptions(lookups, LK.LookupKeys.SecuredTypes),
                sidingTypes: this.buildOptions(lookups, LK.LookupKeys.SidingTypes),
                streetTypes: this.buildOptions(lookups, LK.LookupKeys.StreetTypes),
            }
        };

        if (_.size(result.assocNotes)) {
            result.assocNotes = _.filter(result.assocNotes, (o) => Formatters.getStr(o, 'notes') !== '');
            if (_.size(result.assocNotes)) {
                result.assocNotes = _.orderBy(result.assocNotes, ['created'], ['desc']);
            }
        }

        if (_.size(result.assocNotesDelete)) {
            result.assocNotes = _.omitBy(result.assocNotes, (o) => _.includes(result.assocNotesDelete, o.objectId));
        }

        return _.merge(result, this.state.formChanges);
    }

    public getFormChangesCount() {
        const numChanges = _.sum(_.map(_.mapValues(this.state.formChanges, (o, k) => (k === 'name') ? 1 : _.size(o)), (p) => p));
        return numChanges;
        // return _.size(this.state.formChanges);
    }

    public getFormChangesResetRequired() {
        let resetFormData = false;
        // Props values
        const pa = Formatters.getInt(this.props, 'associationId');

        // Cached values
        const ca = Formatters.getInt(this.originalFormDataCache, 'associationId');

        // Determine if formdata state and cache needs reset due to changing associd or invid
        if (pa && ca) {
            resetFormData = (pa !== ca) ? true : false;
        }

        return resetFormData;
    }

    // Renderers
    public renderButtonToolbar = (associationId: any) => {
        let buttonProps = {
            bsSize: 'sm',
        };

        let saveChangesButtonProps = {
            bsStyle: 'default',
            bsSize: 'sm',
            disabled: true,
            title: this.appText('no-changes'),
        };

        if (this.getFormChangesCount()) {
            saveChangesButtonProps = {
                bsStyle: 'success',
                bsSize: 'sm',
                disabled: false,
                title: `${this.appText('save')} ${Formatters.plural(this.appText('change'), this.getFormChangesCount(), false)}`,
            };
        }

        return (
            <div>
                <Well>
                    <Row>
                        <Col xs={9}>
                            <ButtonToolbar>
                                <ButtonGroup>
                                    <Button {...saveChangesButtonProps} onClick={e => { this.handleSaveButton(e); }}><i className="glyphicon glyphicon-floppy-disk" /> {saveChangesButtonProps.title}</Button>
                                </ButtonGroup>

                                {/* <ButtonGroup>
                                    <Button {...buttonProps} bsStyle="info" onClick={e => { this.handleNewButton(e); }}>
                                        <i className="glyphicon glyphicon-plus" /> {this.appText('buttons.new')}
                                    </Button>

                                    <Button {...buttonProps} bsStyle="info" onClick={e => { this.handleDuplicateButton(e); }}>
                                        <i className="glyphicon glyphicon-copy" /> {this.appText('buttons.duplicate')}
                                    </Button>

                                    <Button {...buttonProps} bsStyle="info" onClick={e => { this.handleCalculateButton(e); }}>
                                        <i className="fa fa-calculator" /> {this.appText('buttons.calculate')}
                                    </Button>
                                </ButtonGroup>

                                <ButtonGroup>
                                    <Button {...buttonProps} bsStyle="info" onClick={e => { this.handlePropertyButton(e); }}>
                                        <i className="glyphicon glyphicon-th-list" /> {this.appText('buttons.property')}
                                    </Button>

                                    <Button {...buttonProps} bsStyle="info" onClick={e => { this.handleInventoryButton(e); }}>
                                        <i className="glyphicon glyphicon-th-list" /> {this.appText('buttons.inventory')}
                                    </Button>

                                    <Button {...buttonProps} bsStyle="info" onClick={e => { this.handleResearchComponentsButton(e); }}>
                                        <i className="glyphicon glyphicon-tasks" /> {this.appText('buttons.research-components')}
                                    </Button>

                                    <Button {...buttonProps} bsStyle="info" onClick={e => { this.handleAddResearchButton(e); }}>
                                        <i className="glyphicon glyphicon-plus" /> {this.appText('buttons.add-research')}
                                    </Button>
                                </ButtonGroup> */}
                            </ButtonToolbar>
                        </Col>
                        <Col xs={3} />
                    </Row>
                </Well>
            </div>
        );
    }

    public render() {
        const {
            associationId,
            association,
            lookups,
            clients,
            ...rest
        } = this.props;

        const assoc = this.extendAssociationData(association);

        const pageTitle = this.appTextPageTitleAppendString(_.get(assoc, 'name', ''), 'page-title', true);
        let page = (<div />);
        if (Number(_.get(assoc, 'associationId', -1)) === Number(associationId)) {
            const formData = this.getFormData(assoc, lookups);

            // lookupsClients, lookupsAssociationTypes, lookupsCompanies, lookupsStates, lookupsCountries,
            //     lookupsStreets, lookupsRoofs, lookupsPaintedExteriors, lookupsFencing, lookupsInteriorHallways, lookupsIrrigation,
            //     lookupsSecured, lookupsMechanical, lookupsElevators, lookupsClubhouses);

            // console.log('pageData', {
            //     assoc: assoc,
            //     clients: clients,                    
            //     formData: formData,
            //     numChanges: this.getFormChangesCount(),
            //     formChanges: this.state.formChanges,
            // });

            if (this.getFormChangesResetRequired() || !_.size(this.originalFormDataCache)) {
                this.originalFormDataCache = _.cloneDeep(formData);
            }

            page = (
                <div>
                    {this.renderButtonToolbar(associationId)}

                    <WhiteBoxPageSection title="">
                        <KendoWrappers.KendoHorizontalForm>
                            <Row className="form-row">
                                <Col xs={4} xl={4}>
                                    <Row>
                                        <Col xs={12}>
                                            <AssociationDetailsLocation
                                                appText={(e) => this.appText(e)}
                                                handleFormInputChange={(n, v) => this.handleFormInputChange(n, v)}
                                                handleSubmitForm={(e) => this.handleSaveButton(e)}
                                                handleSaveChanges={(e) => this.handleSaveButton(e)}
                                                formData={formData}
                                                numFormChanges={this.getFormChangesCount()}
                                                defaultInputProps={{ colLabelXs: 4, colInputXs: 8 }}
                                                sectionTitle={this.appText('section-title.location')}
                                                {...rest}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12}>
                                            <AssociationDetailsConstructionInformation
                                                appText={(e) => this.appText(e)}
                                                handleFormInputChange={(n, v) => this.handleFormInputChange(n, v)}
                                                handleSubmitForm={(e) => this.handleSaveButton(e)}
                                                handleSaveChanges={(e) => this.handleSaveButton(e)}
                                                formData={formData}
                                                numFormChanges={this.getFormChangesCount()}
                                                defaultInputProps={{ colLabelXs: 4, colInputXs: 8 }}
                                                sectionTitle={this.appText('section-title.construction-info')}
                                                {...rest}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12}>
                                            <AssociationDetailsCommonAreaAmenities
                                                appText={(e) => this.appText(e)}
                                                handleFormInputChange={(n, v) => this.handleFormInputChange(n, v)}
                                                handleSubmitForm={(e) => this.handleSaveButton(e)}
                                                handleSaveChanges={(e) => this.handleSaveButton(e)}
                                                formData={formData}
                                                numFormChanges={this.getFormChangesCount()}
                                                defaultInputProps={{ colLabelXs: 4, colInputXs: 8 }}
                                                sectionTitle={this.appText('section-title.common-area-amenities')}
                                                {...rest}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={8} xl={8}>
                                    <Row>
                                        <Col xs={12}>
                                            <AssociationDetails
                                                appText={(e) => this.appText(e)}
                                                handleFormInputChange={(n, v) => this.handleFormInputChange(n, v)}
                                                handleSubmitForm={(e) => this.handleSaveButton(e)}
                                                handleSaveChanges={(e) => this.handleSaveButton(e)}
                                                formData={formData}
                                                numFormChanges={this.getFormChangesCount()}
                                                defaultInputProps={{ colLabelXs: 4, colInputXs: 8 }}
                                                sectionTitle={this.appText('section-title.details')}
                                                {...rest}
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col xs={12}>
                                            <AssociationDetailsAmenityResponsibilitiesExteriorCheckboxes
                                                appText={(e) => this.appText(e)}
                                                handleFormInputChange={(n, v) => this.handleFormInputChange(n, v)}
                                                handleSubmitForm={(e) => this.handleSaveButton(e)}
                                                handleSaveChanges={(e) => this.handleSaveButton(e)}
                                                formData={formData}
                                                numFormChanges={this.getFormChangesCount()}
                                                defaultInputProps={{ colLabelXs: 4, colInputXs: 8 }}
                                                sectionTitle={this.appText('section-title.amenity-responsibilities-exterior')}
                                                {...rest}
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col xs={12}>
                                            <AssociationDetailsAmenityResponsibilitiesExteriorNumeric
                                                appText={(e) => this.appText(e)}
                                                handleFormInputChange={(n, v) => this.handleFormInputChange(n, v)}
                                                handleSubmitForm={(e) => this.handleSaveButton(e)}
                                                handleSaveChanges={(e) => this.handleSaveButton(e)}
                                                formData={formData}
                                                numFormChanges={this.getFormChangesCount()}
                                                defaultInputProps={{ colLabelXs: 4, colInputXs: 8 }}
                                                sectionTitle={this.appText('section-title.amenity-responsibilities-exterior')}
                                                {...rest}
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col xs={12}>
                                            <AssociationDetailsAmenityResponsibilitiesInterior
                                                appText={(e) => this.appText(e)}
                                                handleFormInputChange={(n, v) => this.handleFormInputChange(n, v)}
                                                handleSubmitForm={(e) => this.handleSaveButton(e)}
                                                handleSaveChanges={(e) => this.handleSaveButton(e)}
                                                formData={formData}
                                                numFormChanges={this.getFormChangesCount()}
                                                defaultInputProps={{ colLabelXs: 4, colInputXs: 8 }}
                                                sectionTitle={this.appText('section-title.amenity-responsibilities-interior')}
                                                {...rest}
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col xs={12}>
                                            <AssociationDetailsNotes
                                                appText={(e) => this.appText(e)}
                                                handleFormInputChange={(n, v) => this.handleFormInputChange(n, v)}
                                                handleSubmitForm={(e) => this.handleSaveButton(e)}
                                                handleSaveChanges={(e) => this.handleSaveButton(e)}
                                                formData={(formData) ? formData : 'Testing'}
                                                numFormChanges={this.getFormChangesCount()}
                                                defaultInputProps={{ colLabelXs: 4, colInputXs: 8 }}
                                                sectionTitle={this.appText('section-title.notes')}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </KendoWrappers.KendoHorizontalForm>
                    </WhiteBoxPageSection>
                </div>
            );
        }

        return (
            <AppComp.RenderPageWithLayout branding={this.props.branding} pageName={pageTitle} {...rest}>
                {page}
            </AppComp.RenderPageWithLayout>
        );
    }
}

const getApiUrlLookups = () => ApiEndpoints.getLookupsByKeyUrl([
    LK.LookupKeys.Companies,
    LK.LookupKeys.Regions,
    LK.LookupKeys.StreetTypes,
    LK.LookupKeys.AssociationTypes,
    LK.LookupKeys.Clients,
    LK.LookupKeys.RoofTypes,
    LK.LookupKeys.SidingTypes,
    LK.LookupKeys.FencingTypes,
    LK.LookupKeys.InteriorHallTypes,
    LK.LookupKeys.IrrigationTypes,
    LK.LookupKeys.SecuredTypes,
    LK.LookupKeys.MechanicalTypes,
    LK.LookupKeys.ElevatorTypes,
    LK.LookupKeys.RecRoomTypes,
]);

const getApiUrl = props => ApiEndpoints.getAssociationDetailUrl(props.match.params.associationId);

const mapPropsToConfigs = (props) => {
    return [
        ReduxQueries.Queries.getAssociationDetailRequest(
            getApiUrl(props),
            ReduxQueries.PropsAccessToken(props),
        ),

        ReduxQueries.Queries.getLookupsByKeyRequest(
            getApiUrlLookups(),
            ReduxQueries.PropsAccessToken(props)
        ),
    ];
};

const mapStateToProps = (state, props) => {
    const associationId = _.get(props, 'match.params.associationId', 0);

    const mapped = ReduxQueries.MapQueryStateToPropsByUrl(getApiUrl(props), state, props, {
        associationId: associationId,
        association: state.entities.associationDetailAssociation,
        clients: state.entities.associationDetailClients,
    });

    return mapped;
};

const mapDispatchToProps = {
    updateAssociation: MutateActions.updateAssociationMutateAsync,
    navigateTo: (path) => push(path),
};

const EditAssociationContainer = compose<any>(
    connect(mapStateToProps, mapDispatchToProps),
    connectRequest(mapPropsToConfigs)
)(EditAssociation);

export default withRouter(EditAssociationContainer);



// WEBPACK FOOTER //
// ./src/association/edit.tsx